const SET_AVAILABLE_JOB_USAGE_BUDGET = 'SET_AVAILABLE_JOB_USAGE_BUDGET';

const SET_JOB_USAGE_BUDGET_REQUESTS = 'SET_JOB_USAGE_BUDGET_REQUESTS';

const SET_UPDATED_JOB_USAGE_REQUEST_STATUS = 'SET_UPDATED_JOB_USAGE_REQUEST_STATUS';

const SET_UPDATED_JOB_USAGE_REQUEST_STATUS_FOR_REQUEST = 'SET_UPDATED_JOB_USAGE_REQUEST_STATUS_FOR_REQUEST';
const SET_AVAILABLE_USER_BUDGET = 'SET_AVAILABLE_USER_BUDGET';
const SET_USER_BUDGET_REQUESTS = 'SET_USER_BUDGET_REQUESTS';
const SET_UPDATED_USER_REQUEST_STATUS_FOR_REQUEST = 'SET_UPDATED_USER_REQUEST_STATUS_FOR_REQUEST';
const SET_UPDATED_USER_REQUEST_STATUS = 'SET_UPDATED_USER_REQUEST_STATUS';

export {
  SET_AVAILABLE_JOB_USAGE_BUDGET,
  SET_JOB_USAGE_BUDGET_REQUESTS,
  SET_UPDATED_JOB_USAGE_REQUEST_STATUS,
  SET_UPDATED_JOB_USAGE_REQUEST_STATUS_FOR_REQUEST,
  SET_AVAILABLE_USER_BUDGET,
  SET_USER_BUDGET_REQUESTS,
  SET_UPDATED_USER_REQUEST_STATUS_FOR_REQUEST,
  SET_UPDATED_USER_REQUEST_STATUS,
};
